import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19.397 6.389H4.604a.766.766 0 0 1 0-1.53h14.793a.766.766 0 0 1 0 1.53zM20.162 12a.766.766 0 0 0-.765-.765H4.604a.766.766 0 0 0 0 1.53h14.793a.766.766 0 0 0 .765-.765zm0 6.376a.766.766 0 0 0-.765-.765H4.604a.766.766 0 0 0 0 1.53h14.793a.766.766 0 0 0 .765-.765z"
}), 'BurgerMenu');